import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinkaregaonmidc() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Karegaon MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Karegaon MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited offers dependable and professional Corporate Cab Services in Karegaon MIDC, providing smooth and efficient transportation solutions for factories, manufacturing units, warehouses, and corporate offices in the area. Our fleet of clean, air-conditioned sedans, SUVs, and employee-transport vehicles ensures comfortable and punctual commuting for staff, managers, executives, and visiting clients. With trained chauffeurs, GPS-enabled vehicles, and flexible rental plans, we deliver safe, reliable, and well-organized mobility services. Whether your company requires shift-based employee pick-and-drop, dedicated corporate vehicles, client transfers, or outstation business travel, Pune Corporate Cars India Private Limited provides high-quality and hassle-free transportation tailored to the needs of Karegaon MIDC.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Karegaon Employee Transport",
    "description": "Karegaon Employee Transport provides dependable and well-organized commuting solutions for workers and staff employed in Karegaon MIDC. With AC sedans, shared cabs, vans, and shuttle vehicles, the service ensures punctual pickup–drop operations across multiple shifts. Karegaon Employee Transport is ideal for factories, warehouses, corporate units, and production plants requiring safe, daily staff mobility."
  },
  {
    "name": "Karegaon Staff Pickup Drop",
    "description": "Karegaon Staff Pickup Drop offers seamless daily employee travel with systematic pickup and drop routes across Karegaon and nearby areas. The service is designed to support night shifts, early morning factory operations, and multi-route employee commute. Karegaon Staff Pickup Drop ensures comfort, safety, and reliability for all categories of industrial employees."
  },
  {
    "name": "Karegaon Industrial Cab Service",
    "description": "Karegaon Industrial Cab Service is tailored for industries, manufacturing units, and production facilities in Karegaon MIDC. With professional drivers, GPS-enabled cabs, and well-maintained vehicles, the service ensures smooth workforce mobility. Karegaon Industrial Cab Service supports shift-based schedules and efficient commuting for industrial operations."
  },
  {
    "name": "Business Taxi Karegaon",
    "description": "Business Taxi Karegaon provides professional executive travel for managers, supervisors, and business visitors. Offering AC sedans and SUVs, the service ensures comfort, punctuality, and a premium travel experience for business meetings, plant visits, and corporate travel requirements in and around Karegaon."
  },
  {
    "name": "Company Cab Service Karegaon",
    "description": "Company Cab Service Karegaon delivers managed cab services for organizations needing structured employee commute and executive mobility. The fleet includes sedans, vans, SUVs, and shuttle vehicles driven by trained professionals. Company Cab Service Karegaon ensures reliable, clean, and safe transportation for corporate teams."
  },
  {
    "name": "Affordable Corporate Cabs Karegaon",
    "description": "Affordable Corporate Cabs Karegaon offers cost-effective travel solutions without compromising on safety or comfort. Ideal for small and medium-sized industries, the service includes shared cabs, fixed-route travel, and economic monthly plans. Affordable Corporate Cabs Karegaon helps companies reduce travel costs while maintaining dependable employee commute."
  },
  {
    "name": "Employee Commute Karegaon MIDC",
    "description": "Employee Commute Karegaon MIDC provides structured transportation for employees working across Karegaon’s industrial zones. With timely pickup, safe routes, and trained drivers, the service ensures smooth travel for all work shifts. Employee Commute Karegaon MIDC is trusted by factories and corporate units for its reliable mobility support."
  },
  {
    "name": "Corporate Fleet Karegaon",
    "description": "Corporate Fleet Karegaon offers a fully managed fleet of sedans, SUVs, shuttles, and staff vehicles for corporate mobility. Perfect for employee commute, executive travel, and inter-branch movement, the service ensures consistent vehicle availability, professional chauffeurs, and optimized transport management."
  },
  {
    "name": "Best Cab Provider Karegaon",
    "description": "Best Cab Provider Karegaon delivers high-quality and professional cab services for corporate, industrial, and business travel needs. The service includes premium sedans, SUVs, vans, and shuttles equipped with AC and maintained for daily operations. Best Cab Provider Karegaon ensures comfort, safety, and punctuality every day."
  },
  {
    "name": "Monthly Cab Hire Karegaon",
    "description": "Monthly Cab Hire Karegaon offers long-term cab rental solutions for companies needing regular employee commuting and executive travel. With dedicated vehicles, fixed monthly billing, and priority support, this service ensures consistent and cost-effective mobility. Monthly Cab Hire Karegaon is ideal for continuous corporate operations."
  },
  {
    "name": "Outstation Cab Karegaon MIDC",
    "description": "Outstation Cab Karegaon MIDC provides safe, comfortable, and punctual long-distance cab services for corporate clients, supervisors, and business visitors. With AC sedans and SUVs operated by trained drivers, the service supports intercity meetings, multi-location factory visits, and outstation corporate travel."
  },
  {
    "name": "Sedan Cab Karegaon",
    "description": "Sedan Cab Karegaon offers executive AC sedans ideal for business travel, office commute, and intercity corporate trips. Clean interiors, professional chauffeurs, and comfortable seating ensure a smooth and premium travel experience. Sedan Cab Karegaon is perfect for supervisors, managers, and corporate staff."
  },
  {
    "name": "SUV Cab Karegaon",
    "description": "SUV Cab Karegaon provides spacious and comfortable SUV options for long-distance travel, plant visits, and executive mobility. With superior seating, powerful AC, and trained drivers, SUV Cab Karegaon ensures a premium and reliable corporate travel experience."
  },
  {
    "name": "Worker Transport Karegaon",
    "description": "Worker Transport Karegaon offers shuttle vans, tempo travellers, and group transport solutions for factory workers and industrial staff. Ideal for large workforces, shift-based operations, and bulk movement, Worker Transport Karegaon ensures safe, timely, and economical commuting for manufacturing units."
  },
  {
    "name": "Corporate Shuttle Karegaon",
    "description": "Corporate Shuttle Karegaon delivers high-capacity shuttle services for companies requiring mass employee commuting. The service features fixed routes, multi-shift support, and professionally managed driver operations. Corporate Shuttle Karegaon ensures efficient and organized transport for large industrial teams."
  }
],
"tableData": [
  ["Karegaon Employee Transport", "Karegaon Staff Pickup Drop"],
  ["Karegaon Industrial Cab Service", "Business Taxi Karegaon"],
  ["Company Cab Service Karegaon", "Affordable Corporate Cabs Karegaon"],
  ["Employee Commute Karegaon MIDC", "Corporate Fleet Karegaon"],
  ["Best Cab Provider Karegaon", "Monthly Cab Hire Karegaon"],
  ["Outstation Cab Karegaon MIDC", "Sedan Cab Karegaon"],
  ["SUV Cab Karegaon", "Worker Transport Karegaon"],
  ["Corporate Shuttle Karegaon", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Karegaon MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides dependable and efficient corporate cab services in Karegaon MIDC, tailored for industries, warehouses, and corporate offices in the region."
  },
  {
    "WhyChooseheading": "Ideal for Industrial & Corporate Travel",
    "WhyChoosedescription": "Our cab services are perfectly suited for employees and executives commuting to manufacturing units and industrial setups in Karegaon MIDC."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "All our cabs are well-maintained, sanitized, and equipped to offer a safe, smooth, and comfortable travel experience every day."
  },
  {
    "WhyChooseheading": "Affordable Corporate Travel Plans",
    "WhyChoosedescription": "We offer cost-effective monthly and long-term transportation packages designed specifically for corporate requirements."
  },
  {
    "WhyChooseheading": "Timely Pickup and Drop Services",
    "WhyChoosedescription": "Our drivers follow strict punctuality to ensure employees reach on time for their shifts and return safely after work."
  },
  {
    "WhyChooseheading": "Professional and Trained Drivers",
    "WhyChoosedescription": "Our drivers are experienced, disciplined, and trained to provide a safe and respectful corporate commuting experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "We provide round-the-clock support to handle schedule changes, route adjustments, or emergency requirements."
  },
  {
    "WhyChooseheading": "Smooth and Hassle-Free Booking",
    "WhyChoosedescription": "Booking employee transportation for Karegaon MIDC is easy and fast with our streamlined booking process."
  }
]























  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited provide corporate cab services in Karegaon MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies operating in Karegaon MIDC.',
  },
  {
    question: 'How can companies in Karegaon MIDC book corporate cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Do you provide employee pickup and drop services in Karegaon MIDC?',
    answer: 'Yes, we offer punctual and structured employee pickup and drop services for Karegaon MIDC industries.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Karegaon MIDC?',
    answer: 'We provide hatchbacks, sedans, SUVs, and tempo travellers suitable for staff transportation and business requirements.',
  },
  {
    question: 'Can companies opt for monthly or yearly transportation contracts?',
    answer: 'Absolutely. We offer flexible and cost-effective monthly and annual corporate cab contracts for Karegaon MIDC companies.',
  },
  {
    question: 'Are your drivers familiar with Karegaon MIDC routes?',
    answer: 'Yes, our drivers are well-versed with Karegaon MIDC and nearby routes, ensuring timely and safe transportation.',
  },
  {
    question: 'Do you support shift-based cab services for industries in Karegaon MIDC?',
    answer: 'Yes, we handle all shift schedules including early morning, late night, and rotational shifts.',
  },
  {
    question: 'What safety and hygiene measures are maintained for corporate cab services?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene standards.',
  },
  {
    question: 'What payment options are available for corporate transportation in Karegaon MIDC?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and also provide corporate billing options.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Jayesh Landge',
    feedback: 'Pune Corporate Cars India Private Limited offers excellent cab services in Karegaon MIDC. Their punctuality and professionalism are commendable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ashwini Bhope',
    feedback: 'Reliable, clean cabs and experienced drivers. Perfect corporate cab solution for Karegaon MIDC companies.',
    rating: 5,
  },
];
















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Karegaon MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-karegaon.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Karegaon MIDC, Pune, offering employee transport, industrial staff pickup and drop, office and factory commute, and business travel cabs. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for companies and industrial units in Karegaon.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-karegaon-midc"
  }
};








  return (
    <div>
      <Helmet>
  <title>Corporate Cab Services in Karegaon MIDC | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Karegaon MIDC, Pune, offering employee transport, industrial staff pickup and drop, office and factory commute, and business travel cabs. Chauffeur-driven sedans, SUVs, and outstation cabs for companies and industrial units in Karegaon."
  />

  <meta
    name="keywords"
    content="Karegaon Employee Transport, Karegaon Staff Pickup Drop, Karegaon Industrial Cab Service, Business Taxi Karegaon, Company Cab Service Karegaon, Affordable Corporate Cabs Karegaon, Employee Commute Karegaon MIDC, Corporate Fleet Karegaon, Best Cab Provider Karegaon, Monthly Cab Hire Karegaon, Outstation Cab Karegaon MIDC, Sedan Cab Karegaon, SUV Cab Karegaon, Worker Transport Karegaon, Corporate Shuttle Karegaon"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinkaregaonmidc;